module.exports = __webpack_public_path__ + "static/media/laptop-result.698de06a.png";